export default __webpack_public_path__ + "static/mi-bg-b381f614dec9765a5d2190bb8ca320ff.png";